import React, { useState } from 'react'
import Input from './Input'
import ButtonWithLoader from './ButtonWithLoader'
import { useSelector, useDispatch } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { SET_NEW_PASSWORD } from '../redux/authReducer'
import { useParams } from 'react-router-dom'
type Props = {}

const NewPasswordScreen = (props: Props) => {
  const { secureId } = useParams()
  const isLoading = useSelector((state: RootReducer) => state.authReducer.isLoading)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')

  const dispatch = useDispatch()

  const handleSubmit = () => {
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match')
      return
    }
    setPasswordError('')
    const hasLetter = /[a-zA-Z]/.test(password)
    const hasDigit = /[0-9]/.test(password)
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password)
    const isLongEnough = password.length >= 8
    if (!hasLetter || !hasDigit || !hasSpecial || !isLongEnough) {
      setPasswordError(
        'Password must be at least 8 characters long and contain at least one letter, one number, and one special character'
      )
      return
    }
    dispatch(SET_NEW_PASSWORD({ secureId: secureId as string, password }))
  }

  return (
    <div className="overflow-hidden bg-coolGray h-screen">
      <div className="relative z-1">
        <div className="md:h-[7.5rem] h-[0px]" />
        <div className="flex items-center justify-center">
          <div className="max-w-[30rem] flex-1 bg-slateGray p-8 rounded-2xl mx-2 md:mx-0">
            <h4 className="text-36 font-domine text-center text-white">Create New Password</h4>
            <p className="text-lightIceBlue font-sans text-center text-18">Please enter your new password</p>
            <div className="h-[2rem]" />
            <Input
              onChange={(e) => setPassword(e.target.value)}
              name={'password'}
              type="password"
              label="New Password"
              error={passwordError.length > 0}
            />
            <div className="h-[1rem]" />
            <Input
              onChange={(e) => setConfirmPassword(e.target.value)}
              name={'confirmPassword'}
              type="password"
              label="Confirm New Password"
              error={passwordError.length > 0}
            />
            {passwordError && <p className="text-red-500 text-sm mt-2 text-center">{passwordError}</p>}
            <div className="h-[1rem]" />
            <ButtonWithLoader onClick={handleSubmit} label="Set New Password" isLoading={isLoading} />
            <div className="h-[1rem]" />
          </div>
        </div>
        <div className="md:h-[7.5rem] h-[0px]" />
      </div>
    </div>
  )
}

export default NewPasswordScreen
